module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-e9331ed9e378d5e964ba22f4eeda07e8.svg";